import { useEffect } from "react";

interface SettingsListenerConfig {
  onOpenSettings: () => void;
}

/**
 * Listens for programmatic settings open events from other components
 * (e.g., from terminal integration cards via window.dispatchEvent).
 * Triggered by the "ano:open-workspace-settings" event.
 */
export function useSidebarSettingsOpenListener({
  onOpenSettings,
}: SettingsListenerConfig) {
  useEffect(() => {
    const handler = () => onOpenSettings();
    window.addEventListener("ano:open-workspace-settings", handler);
    return () =>
      window.removeEventListener("ano:open-workspace-settings", handler);
  }, [onOpenSettings]);
}
